import { render, staticRenderFns } from "./icon-kakao.vue?vue&type=template&id=276ff003&scoped=true"
import script from "./icon-kakao.vue?vue&type=script&lang=js"
export * from "./icon-kakao.vue?vue&type=script&lang=js"
import style0 from "./icon-kakao.vue?vue&type=style&index=0&id=276ff003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ff003",
  null
  
)

export default component.exports